var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"analytics-dashboard-header-box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8"},[_c('h1',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"col-4"},[_vm._t("filter")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }